import React from 'react'
import Alert from '@material-ui/lab/Alert'
import { FormattedMessage } from 'react-intl'
import { Dialog, DialogContent, IconButton, Slide } from '@material-ui/core'
import { useStyles } from '../TaxServicesErrorDialog/Styles'
import CloseIcon from '@material-ui/icons/Close'
import { NavLink } from 'react-router-dom'
import { NamedRoutes } from '../../../routes'
import { formatRoute } from 'react-router-named-routes'
import { AuthenticatedUserConsumer } from '../../../AuthenticatedUserContext'

const messagesWithDelegatesLink = [
  'InheritedReality.taxService.ErrorAlert'
]

const Transition = React.forwardRef(function Transition (props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const MenuItemDialog = () => {
  const classes = useStyles()
  return (
    <AuthenticatedUserConsumer>
      {({ selectedCompany, menuItemDialogOpen, menuItemDialogMessageId, closeMenuItemDialog }) => (
        <Dialog
          fullWidth
          maxWidth={'sm'}
          open={menuItemDialogOpen}
          classes={{ paper: classes.ErrorDialogPaper }}
          onClose={closeMenuItemDialog}
          TransitionComponent={Transition}
          aria-labelledby="MenuItemDialog"
          aria-describedby="MenuItemDialog"
        >
          <DialogContent className={classes.ErrorDialogContent}>
            <IconButton
              edge={false}
              className={classes.ErrorDialogClose}
              color="inherit"
              aria-label="close dialog"
              onClick={closeMenuItemDialog}
            >
              <CloseIcon/>
            </IconButton>
            <Alert severity="error" className={classes.linkCompanyErrorMessage}>
              {!!menuItemDialogMessageId && (
                <FormattedMessage
                  id={menuItemDialogMessageId}
                  values={messagesWithDelegatesLink.includes(menuItemDialogMessageId) ? {
                    a: chunks => <NavLink
                      onClick={closeMenuItemDialog}
                      to={formatRoute(NamedRoutes.workspace.company.delegates, { id: selectedCompany?.id })}>{chunks}</NavLink>
                  } : undefined}
                />
              )}
            </Alert>
          </DialogContent>
        </Dialog>
      )}
    </AuthenticatedUserConsumer>
  )
}

export default MenuItemDialog
